import { useEffect } from 'react';
import { AccountOverview } from 'components/AccountOverview/AccountOverview';
import { BaseLayout } from 'components/Layout/BaseLayout/BaseLayout';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { useLocale } from 'hooks/useLocale';
import { useNavigate } from 'react-router-dom';
import { PATH_NAMES } from 'utils/routes/pathNames';

export const AccountOverviewPage = () => {
  const navigate = useNavigate();
  const { isUK } = useLocale();
  const { introducerType } = useIntroducerData();
  const hasAccessToAccountOverview = isUK && introducerType !== 'partner';

  useEffect(() => {
    if (!hasAccessToAccountOverview) {
      navigate(PATH_NAMES.home());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasAccessToAccountOverview]);

  if (!hasAccessToAccountOverview) return null;

  return (
    <BaseLayout pageTitle="Account overview | Introducer Portal">
      <AccountOverview />
    </BaseLayout>
  );
};
